module.exports = __webpack_public_path__ + "img/weibo.c171eda5.png";